import { type ConfirmDepositInput, confirmDepositInputSchema } from '@repo/api-contracts';
import { useId, useState } from 'react';
import { formStyles, Input, Label, OrderActionDialog } from '@/shared/ui';

interface Props {
  readonly orderId: string;
  readonly defaultDepositorName: string;
  readonly today: string;
  readonly onSubmit: (input: ConfirmDepositInput) => Promise<void>;
  readonly onReload: () => void;
  readonly onClose: () => void;
  readonly pending?: boolean;
}
export function ConfirmDepositDialog({
  orderId,
  defaultDepositorName,
  today,
  onSubmit,
  onReload,
  onClose,
  pending,
}: Props) {
  const id = useId();
  const [date, setDate] = useState(today);
  const [name, setName] = useState(defaultDepositorName);
  const [memo, setMemo] = useState('');
  const input = { orderId, depositedOn: date, depositorName: name, memo };
  return (
    <OrderActionDialog
      title="입금 확인"
      submitLabel="입금 확인"
      onReload={onReload}
      onClose={onClose}
      pending={pending}
      validate={() =>
        confirmDepositInputSchema.safeParse(input).success
          ? null
          : '입금일과 입금자명을 확인해 주세요.'
      }
      onSubmit={async () => {
        await onSubmit(input);
        return '입금이 확인되었습니다.';
      }}
    >
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-date`}>입금일</Label>
        <Input
          id={`${id}-date`}
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-name`}>입금자명</Label>
        <Input id={`${id}-name`} value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-memo`}>메모</Label>
        <Input id={`${id}-memo`} value={memo} onChange={(e) => setMemo(e.target.value)} />
      </div>
    </OrderActionDialog>
  );
}
